export default __webpack_public_path__ + "static/media/before-you-start.a8db14e6.svg";